<template>
  <header class="profile_header">
    <div v-if="isLoaded" class="profile_header_content" :style="`background-color: ${bgColor};`">
      <div class="profile_header_content_show container-fluid">
        <div class="row py-4">

          <div class="col-12 d-flex align-items-center t-white">
            <!-- picture -->
            <i class="t-xxxlr mr-3" :class="renderOrganisationCategoryIcon(organisation.organisation_types)"></i>
            <h1 class="t-white t-500" v-html="organisation.highlights.name" />
          </div>
          <div class="col-12 d-flex align-items-baseline">
            <div class="t-400 t-lr t-white mr-4">
              {{ industryAndTypeString }}
            </div>

            <div v-if="locationString || country" class="mr-4 d-flex align-items-center t-white">
              <span v-if="locationString" class="t-400 t-lg">{{ locationString }}</span>
              <span class="t-xxs pl-2" v-if="country"><flag :title="renderCountryFlagTooltip(country)" :iso="country.alpha_2 | lowercase" :squared="false" class="bd-radius" /></span>
            </div>

            <!-- spinoff from -->
            <div v-if="spinOffParent" class="t-400 t-lg t-400 t-white mt-1">
              Spinoff from <i class="t-sm" :class="renderOrganisationCategoryIcon(spinOffParent.category)" /> {{spinOffParent.name}}
            </div>
          </div>
        </div>
      </div>

      <sub-nav
        v-if="isLoaded"
        :name="`organisation_header_nav`"
        :hasResearch="hasResearch"
        :hasPortfolio="isIncubator || isInvestor"
        :hasNews="hasNews"
        :organisation="organisation"
        inverted
      />

    </div>
    <!-- render spinner if not loaded -->
    <spinner v-if="!isLoaded" :containerClass="`width--50px min-height--150px`" />
  </header>
</template>

<script>
import SubNav from '@/components/shared/nav/SubNav'
import Spinner from '@/components/shared/Spinner'
import organisationMixins from '@/mixins/organisation'

import { COLORS } from '@/assets/js/_data'

export default {
  name: 'organisationHeader',
  mixins: [organisationMixins],
  components: {
    SubNav,
    Spinner
  },
  props: {
    isLoaded: {
      type: Boolean,
      required: true
    },
    hasResearch: {
      type: Boolean,
      required: true
    },
    organisation: {
      type: Object,
      required: true
    },
    hasNews: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  computed: {
    bgColor () {
      return COLORS[this.getMostRelevantOrganisationCategory(this.organisation.organisation_types).toLowerCase()]
    }
  }
}
</script>
